var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Order/Order.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/Order/Order.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/Order/Order.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
context.getSuper(env, "title", b_title, frame, runtime, function(t_11,hole_29) {
if(t_11) { cb(t_11); return; }
hole_29 = runtime.markSafe(hole_29);
output += runtime.suppressValue(hole_29, env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 3, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Bang! Bang! • Оставить заявку"])), env.opts.autoescape);
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\n<div class=\"Order\">\n    <div class=\"Order-wrapper\">\n        <div class=\"Order-select\">\n            <h2 class=\"Order-selectTitle\">";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += " Оставить заявку ";
;
}
else {
output += " Make an order ";
;
}
output += "\n            </h2>\n            ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += "\n            <p>Мы знаем, как с помощью визуальных коммуникаций выделить ваш бизнес на фоне конкурентов, создать\n                уникальный дизайн, помогающий привлекать и удерживать клиентов. Напишите нам, и мы расскажем, как можем\n                помочь развитию вашего бизнеса.</p>\n            <p>Bang! Bang! Studio — это команда профессионалов, специализирующихся на разработке брендинга, создании\n                иллюстрации, лендингов, логотипов и анимационных роликов.</p>\n            ";
;
}
else {
output += "\n            <p>We know how to make your business stand out using visual communications and how to create a unique design\n                that will\n                help to attract and keep the clients. E-mail us, and we’ll tell you how we can help to develop your\n                business.</p>\n            <p>Bang! Bang! Studio is a team of professionals, specializing in creating branding, illustrations,\n                landings, logos and animations.</p>\n            ";
;
}
output += "\n            <div class=\"Order-selectList\">\n                ";
frame = frame.push();
var t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"selectList");
if(t_14) {t_14 = runtime.fromIterator(t_14);
var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("item", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
output += "\n                    ";
if(runtime.memberLookup((t_15),"value") != "Poster") {
output += "\n                        <div class=\"Order-selectListItem\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_15),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_15),"value"), env.opts.autoescape);
output += "</div>\n                    ";
;
}
output += "\n                ";
;
}
}
frame = frame.pop();
output += "\n            </div>\n            <div class=\"Order-selectContact desktop\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += "\n                    Не уверены в выборе? \n                    <a href=\"https://t.me/natashaklimchuk\" target=\"_blank\">Напишите</a> нам\n                ";
;
}
else {
output += "\n                    Not sure about your choice?\n                    <a href=\"https://t.me/natashaklimchuk\" target=\"_blank\">Contact us</a>\n                ";
;
}
output += "\n            </div>\n        </div>\n        <div class=\"Order-form\">\n            <div class=\"Order-form-content\">\n                <input name=\"name\" type=\"text\" placeholder=\"* ";
output += runtime.suppressValue((lineno = 44, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Имя"])), env.opts.autoescape);
output += "\" required>\n                <input name=\"email\" type=\"email\" placeholder=\"* Email\" required>\n                <input name=\"phone\" type=\"tel\" placeholder=\"* ";
output += runtime.suppressValue((lineno = 46, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Телефон"])), env.opts.autoescape);
output += "\" required>\n                <div class=\"Order-form-textarea-wrapper\">\n                    <textarea name=\"message\" class=\"Order-form-textarea\" required></textarea>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += "\n                    <label for=\"message\" class=\"Order-form-textarea-placeholder\">\n                        <span class=\"large-text\">* Описание задачи</span>\n                        <span class=\"small-text\">Опишите вашу задачу и мы свяжемся с вами, чтобы просчитать стоимость и\n                            сроки ее исполнения. По возможности, укажите пожелания по стилю, примерный бюджет, сроки и\n                            другие детали.</span>\n                    </label>\n                    ";
;
}
else {
output += "\n                    <label for=\"message\" class=\"Order-form-textarea-placeholder\">\n                        <span class=\"large-text\">* Please describe your task</span>\n                        <span class=\"small-text\">Describe your task, and we will get in touch with you to provide a\n                            quote and estimated timeline. If possible, please include your preferences regarding style,\n                            approximate budget, deadlines, and any other relevant details.</span>\n                    </label>\n                    ";
;
}
output += "\n                </div>\n                <div class=\"Order-formDeal\">\n                    <div class=\"Order-formDeal-circle\"></div>\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += "\n                    <p>Я соглашаюсь с обработкой <a href=\"/privacy/\" target=\"_blank\">персональных данных</a></p>\n                    ";
;
}
else {
output += "\n                    <p>I agree to the <a href=\"/privacy/\" target=\\\"_blank\\\">Privacy Policy</a>\n                        and give my concent to </br><span>the processing of my personal data.</span></p>\n                    ";
;
}
output += "\n                </div>\n                <div class=\"Order-formSend\">";
output += runtime.suppressValue((lineno = 74, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Отправить"])), env.opts.autoescape);
output += "</div>\n            </div>\n            ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += "\n                <div class=\"Order-form-success\">Заявка&nbsp;отправлена! Мы&nbsp;свяжемся&nbsp;с&nbsp;вами\n                    в&nbsp;ближайшее&nbsp;время.</div>\n            ";
;
}
else {
output += "\n                <div class=\"Order-form-success\">Your request has been submitted! We will contact you shortly.</div>\n            ";
;
}
output += "\n        </div>\n        <div class=\"Order-selectContact mobile\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "language") == "ru") {
output += "\n                Не уверены в выборе? \n                <a href=\"https://t.me/natashaklimchuk\" target=\"_blank\">Напишите</a> нам\n            ";
;
}
else {
output += "\n                Not sure about your choice?\n                <a href=\"https://t.me/natashaklimchuk\" target=\"_blank\">Contact us</a>\n            ";
;
}
output += "\n        </div>\n    </div>\n</div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Order/Order.jinja"] , dependencies)